export default __webpack_public_path__ + "static/media/heart-waiting-yellow.54c9de37.svg";